import type { IssueListItem } from "@/pages/Tasks/Issue/config"
import { useHttpClient } from "@/vf"
import { nextTick } from "vue"

interface IssueOfficeParticipantsDto {
    issueId: string
    participants: { name: string }[]
}

export function useIssueOfficeParticipants() {
    const http = useHttpClient()

    async function loadOfficeParticipants(issues: IssueListItem[]) {
        if (!issues || issues.length === 0) {
            return
        }

        const issueIds = issues.map(issue => issue.id)

        const result = (
            await http.get<IssueOfficeParticipantsDto[]>("tasks/issue/office-participants", {
                issueIds,
            })
        ).data

        // Update each issue with office participants
        await nextTick()
        for (const issue of issues) {
            const data = result.find(i => i.issueId === issue.id)
            if (data) {
                issue.officeParticipants = data.participants
            } else {
                issue.officeParticipants = []
            }
        }
    }

    return {
        loadOfficeParticipants,
    }
}
